import { render, staticRenderFns } from "./SqxgDialog.vue?vue&type=template&id=d1ff2cf6&"
import script from "./SqxgDialog.vue?vue&type=script&lang=js&"
export * from "./SqxgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports